export const VIRUS_ICON = "https://firebasestorage.googleapis.com/v0/b/covid-19-1bb90.appspot.com/o/virus_image.png?alt=media&token=8a81a153-acd0-4fcf-9d5d-5f6ef4b67a02"
